import styled from '@emotion/styled'
import { Box } from '@mui/material'

export const LogoContainer = styled(Box)`
  display: flex;
  align-items: center;
  cursor: pointer;
`
